import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import 'react-toastify/dist/ReactToastify.css';
import AnalyticsTracker from './components/AnalyticsTracker';
import AppProvidersWrapper from './components/wrapper/AppProvidersWrapper';
import AuthRoute from './components/AuthRoute'

import NotFound from './pages/extras/NotFound'
import Blog from './pages/blog/Blog' // NEW
import LiveGames from './pages/live/LiveGames' // NEW
import LoginPage from './pages/auth/LoginPage'
import Resources from './pages/resources/Resources'
import Oracle from './pages/oracle/Oracle'
import OracleCRM from './pages/oracle/OracleCRM'


function App() {
  return (
    <Router>
      <AppProvidersWrapper>
        <AuthProvider>
          <AnalyticsTracker />
          <Routes>
            <Route path="/" element={<Navigate to="/oracle" replace />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:id" element={<Blog />} />
            <Route path="/live" element={<LiveGames />} />
            <Route path="/live/:matchId" element={<AuthRoute><LiveGames /></AuthRoute>} />
            <Route path="/live-games" element={<Navigate to="/live" replace />} />
            <Route path="/oracle" element={<Oracle />} />
            <Route path="/oracle/crm" element={<AuthRoute><OracleCRM /></AuthRoute>} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AuthProvider>
      </AppProvidersWrapper>
    </Router>
  )
}

export default App
